/**
 * nts-hl-bus.js — v3
 * Shared event bus. All components communicate through this.
 */
class EventBus {
  constructor() { this._h = {}; }

  on(ev, fn) {
    (this._h[ev] = this._h[ev] || []).push({ fn, once: false });
    return () => this.off(ev, fn);
  }

  once(ev, fn) {
    (this._h[ev] = this._h[ev] || []).push({ fn, once: true });
    return () => this.off(ev, fn);
  }

  off(ev, fn) {
    if (!this._h[ev]) return;
    this._h[ev] = this._h[ev].filter(h => h.fn !== fn);
  }

  emit(ev, payload = {}) {
    const data = { event: ev, ...payload, ts: Date.now() };
    const handlers = [...(this._h[ev] || []), ...(this._h['*'] || [])];
    const toRemove = [];
    handlers.forEach(h => {
      h.fn(data);
      if (h.once) toRemove.push(h);
    });
    toRemove.forEach(h => {
      const list = this._h[ev] || this._h['*'] || [];
      const idx = list.indexOf(h);
      if (idx !== -1) list.splice(idx, 1);
    });
  }
}

window.NTS = window.NTS || {};
window.NTS.bus = new EventBus();
